<template>
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('relationships.admin_title')"/>
        <div class="col-sm-12 nopads my-2">
            <company-relationship-list
              :results="results"
              @add="addRelationship"
              @update="fetchCompanyRelationships"
            />
            <base-modal v-if="editMode" hide-header hide-footer @close="closeEditor">
                <company-relationship-editor @close="closeEditor"/>
            </base-modal>
          <div
            v-if="loading"
            id="loader"
            class="spinner"
          />
        </div>
  </div>
</template>


<script>
import {restApi} from '../../mixins/RestApiMixin'
import {workManagementHelper} from '../../mixins/WorkManagementMixin'
import companyRelationshipList from './CompanyRelationshipList'
import companyRelationshipEditor from './CompanyRelationshipEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'CompanyRelationships',
    components: {BaseModal, Navbar, companyRelationshipList, companyRelationshipEditor},
    mixins: [restApi, workManagementHelper],
    data: function () {
        return {
            results: [],
            loading: true,
            editMode: false
        }
    },
    mounted: function () {
        this.fetchCompanyRelationships()
    },
    methods: {

        fetchCompanyRelationships: function () {
            this.loading = true
            this.results = []
            this.restFetch(this.companyRelationshipUrl, this.handleResponse)
        },

        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },

        addRelationship: function () {
            this.loading = false
            this.editMode = true
        },

        closeEditor: function () {
            this.editMode = false
            this.fetchCompanyRelationships()
        },

        deleteRelationship: function () {
            // TODO
        }

    }
}
</script>
